<button type="button" class="suggestion-badge" (click)="onClick()">
  {{ text }}
</button>
